import {useDebugValue, useEffect} from 'react';

import {useInitialization} from '../../../hooks';
import {getObjectValues} from '../../../utils';

function useFormActions(data) {
    const {
        events: {
            onSettingsChange
        },
        initialSettings,
        changeSettings
    } = data;

    function setSettings(nextSettings) {
        changeSettings(nextSettings);

        onSettingsChange(nextSettings);
    }

    function setSettingsInitial() {
        setSettings(initialSettings);
    }

    function setIsSubmitting(isSubmitting) {
        setSettings({
            isSubmitting
        });
    }

    useEffect(setSettingsInitial, [...getObjectValues(initialSettings)]);

    useInitialization(function initializeSettings() {
        setSettings({
            hasLoaded: true
        });
    });

    const result = {
        setSettings,
        setSettingsInitial,
        setIsSubmitting
    };

    useDebugValue(result);

    return result;
}

export {useFormActions};
